import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './telemetry';
import './i18n';
import './styles/globalStyles.css';
import App from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
